export const qualityToNumber = (quality: string): number => {
    const match = quality.match(/(\d+)p/);
    return match ? parseInt(match[1], 10) : 0;
};
